<script setup>
import HorizontalThemesMenu from '@/components/Menus/Themes/HorizontalThemesMenu.vue'
import ThemeEditPage from '@/views/setup/emails/themes/edit/ThemeEditPage.vue'

definePage({ meta: { pageTitle: 'Create New Theme' } })

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalThemesMenu />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <ThemeEditPage />
      </VCol>
    </VRow>
  </section>
</template>
